///
/// EarthBrowser
///
/// Created by Matt Giger on December 14, 2025
/// Copyright (c) 2025 Geodata Labs
///

import { useEffect } from 'react'
import { Landmark } from 'lucide-react'
import {
	LocationBrowserRenderer,
	LOCATION_BROWSER_WINDOW_ID,
} from '@/components/features/location-browser/LocationBrowserRenderer'
import { CommandRegistry } from '@/components/features/CommandRegistry'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { openOrRestoreWindow } from '@/utils/windowUtils'

const LOCATION_WINDOW_WIDTH = 920
const LOCATION_WINDOW_HEIGHT = 640

export function LocationBrowserFeature() {
	const dispatch = useAppDispatch()
	const datasetWindows = useAppSelector(state => state.dialog.datasetWindows)
	const locationWindow = datasetWindows[LOCATION_BROWSER_WINDOW_ID]

	useEffect(() => {
		const unregister = CommandRegistry.registerFeature({
			id: 'location-browser',
			command: {
				id: 'location',
				title: 'Locations',
				icon: <Landmark className="w-4 h-4 text-blue-400" />,
				category: 'Datasets',
				enabled: true,
				onSelect: () => {
					openOrRestoreWindow(
						dispatch,
						datasetWindows,
						LOCATION_BROWSER_WINDOW_ID,
						{
							id: LOCATION_BROWSER_WINDOW_ID,
							title: 'Cities & Locations',
							windowType: 'location',
							x: 120,
							y: 100,
							width: LOCATION_WINDOW_WIDTH,
							height: LOCATION_WINDOW_HEIGHT,
							isMaximized: false,
							isVisible: true,
						}
					)
				},
			},
			renderBrowser: () => null,
		})

		return unregister
	}, [dispatch, datasetWindows])

	if (!locationWindow) {
		return null
	}

	return (
		<LocationBrowserRenderer
			windowId={LOCATION_BROWSER_WINDOW_ID}
			windowState={locationWindow}
		/>
	)
}
